import {ChevronLeft, ChevronRight} from '@mui/icons-material';
import {Grid} from '@mui/material';

import {CarouselButton} from './CarouselButton';
import {CarouselIndexCounter} from './CarouselIndexCounter';
import {orangeColors} from '../../layouts/theme/designSystem';

interface Props {
  onNextClick: () => void;
  onPreviousClick: () => void;
  currentIndex: number;
  total: number;
  onCounterClick: (idx: number) => void;
}
export const CarouselButtonContainer = ({onPreviousClick, onNextClick, currentIndex, total, onCounterClick}: Props) => {
  const buttonColor = orangeColors[100];
  const activeColor = orangeColors[70];

  return (
    <Grid width='100%' display='flex' justifyContent='space-between'>
      <CarouselButton onClick={onPreviousClick} buttonColor={buttonColor} activeColor={activeColor}>
        <ChevronLeft fontSize='large' sx={{color: '#fff'}} />
      </CarouselButton>
      <CarouselIndexCounter
        currentIndex={currentIndex}
        total={total}
        onClick={onCounterClick}
        buttonColor={buttonColor}
        activeColor={activeColor}
      />
      <CarouselButton onClick={onNextClick} buttonColor={buttonColor} activeColor={activeColor}>
        <ChevronRight fontSize='large' sx={{color: '#fff'}} />
      </CarouselButton>
    </Grid>
  );
};
